<template>
<!-- heyan -->
  <el-container class="content-index-container left-container" :noRoute="true">
    <el-main>
      <que-list></que-list>
    </el-main>
  </el-container>
</template>

<script>
import queList from './components/QueList'
export default {
  name: 'queAnsIndex',
  components: {
    queList,
  },
  provide () {
    return {
      changeCurrentTab: this.changeCurrentTab
    }
  },
  data () {
    return {
      isChild: false, // 是否最底层
      currentTab: 'todo',
      channelId: '',
    }
  },
  methods: {
    changeTab (tab, e) {
    //   this.channelId = this.channelId
    },
    changeCurrentTab () {
      this.currentTab = 'audit'
    }
  },
  activated () {
    
  },
  mounted () {
    
  }

}
</script>

<style lang="scss">
  .content-index-container{
    .left-head{
      padding:10px 10px 0;
      height: 46px;
      border: none;
    }
    .el-tabs__content{
      padding-bottom: 30px !important;
    }
  }
</style>
